export default __webpack_public_path__ + "static/PDP_1-65242dce487d891ca861fcfc4477e0d3.png";